module.exports = __webpack_public_path__ + "img/full2-min.1eb03d99.png";